class UsersImport {
    import(users, chunk, ajaxCallback, completeCallback) {
        if (chunk) {
            users = users.chunk_inefficient(chunk);
        } else {
            users = [users];
        }

        const promiseSerial = funcs =>
            funcs.reduce((promise, func) =>
                    promise.then(result => func().then(Array.prototype.concat.bind(result))),
                Promise.resolve([]));

        const funcs = users.map(part => () => $.ajax({
            url: euAdminConfig.base_uri + euAdminConfig.hostname + '/users/import',
            type: 'post',
            data: {users: part},
            statusCode: {
                200: response => ajaxCallback(response)
            }
        }).fail(response => ajaxCallback('fail')));

        promiseSerial(funcs).then(() => completeCallback());
    }
}

export default UsersImport;
